var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDisableFullscreen = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.843 11.358H1.786a.799.799 0 1 0 0 1.597h5.259v5.259a.799.799 0 1 0 1.597 0v-6.057a.8.8 0 0 0-.799-.799m10.37-4.313h-5.258V1.786a.799.799 0 1 0-1.597 0v6.057c0 .441.358.799.799.799h6.057a.799.799 0 1 0 0-1.597"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.767.233a.797.797 0 0 0-1.127 0l-7.049 7.05a.797.797 0 0 0 1.127 1.126l7.049-7.05a.797.797 0 0 0 0-1.126M8.409 11.591a.797.797 0 0 0-1.127 0l-7.049 7.05a.797.797 0 1 0 1.127 1.126l7.049-7.05a.797.797 0 0 0 0-1.126"
}))));
export default SvgDisableFullscreen;